import * as React from 'react';
import { TParams } from '../../../types/translation.types';
import useText from './use-text.hook';

type TextProps = {
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  tParams?: TParams;
  className?: string;
};

const Text: React.FunctionComponent<TextProps> = ({
  as = 'p',
  tParams,
  children,
  className
}) => {
  const t = useText();

  let content;

  if (tParams) {
    content = t(tParams);
  } else {
    content = children;
  }

  return React.createElement(
    as,
    { className: `ucf-paragraph ${className || ''}` },
    content
  );
};

export default React.memo(Text);
